export default "__VITE_ASSET__Bm4r4TU1__"